import { LucideProps } from 'lucide-react'

const Ribbon = (props: LucideProps & { inverse?: boolean }) => {
  const { inverse, ...other } = props

  return inverse ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 26"
      fill="none"
      {...other}
    >
      <path
        d="M4.51172 3.96875V25.6421L10.1094 22.5171L15.6874 25.6421V3.96875H4.51172Z"
        fill="#E3D9C9"
      />
      <path
        d="M18.875 9.78125C18.875 14.6832 14.902 18.6562 10 18.6562C5.09804 18.6562 1.125 14.6832 1.125 9.78125C1.125 4.87929 5.09804 0.90625 10 0.90625C14.902 0.90625 18.875 4.87929 18.875 9.78125Z"
        fill="white"
        stroke="#DB4245"
        strokeWidth="1.25"
      />
      <path
        d="M12.8371 6.5568L8.82812 10.6875L10.8175 12.4702L14.8265 8.3395L12.8371 6.5568Z"
        fill="#DB4245"
      />
      <path
        d="M7.23025 9.01786L5.375 10.9297L9.08296 14.252L10.9382 12.3402L7.23025 9.01786Z"
        fill="#DB4245"
      />
    </svg>
  ) : (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M5.06641 4.0332V27.6805L11.1739 24.2709L17.2599 27.6805V4.0332H5.06641Z"
        fill="#E2D9C9"
      />
      <path
        d="M11.0527 20.7402C16.7778 20.7402 21.418 16.1 21.418 10.375C21.418 4.64997 16.7778 0.00976562 11.0527 0.00976562C5.3277 0.00976562 0.6875 4.64997 0.6875 10.375C0.6875 16.1 5.3277 20.7402 11.0527 20.7402Z"
        fill="#DB4345"
      />
      <path
        d="M14.1476 6.85442L9.77344 11.3613L11.944 13.3064L16.3181 8.79948L14.1476 6.85442Z"
        fill="white"
      />
      <path
        d="M8.03204 9.54491L6.00781 11.6309L10.0535 15.2558L12.0777 13.1698L8.03204 9.54491Z"
        fill="white"
      />
    </svg>
  )
}

export default Ribbon
